import React from "react";
import styles from "./We-deliver.module.scss";
import Image from "next/image";
import homeStyles from "../../../../styles/Home.module.scss";

function WeDeliver() {
  return (
    <div
      className={`padding4rem center-div ${styles["features-container"]}`}
      id="features"
    >

      <div className={styles["heading-div"]}>
        <div className={styles["ai-container-header"]}>
          <h1>
            Your trusted partner in {" "}
            <span className={homeStyles["span-gradient"]}> modern retail excellence</span>
          </h1>
        </div>
        <p className={styles["sub-heading"]}>Offer hassle-free B2B-style purchasing to your customers on a platform that’s built for excellence</p>
      </div>


      <div className={styles.featuresContainer}>
        <div className={`${styles.featureCard} ${styles.largeCard}`}>
          <div>
            <div className={styles.cardLogoContainer}>
              <Image src="/modernise-icons/headless-commerce.svg" alt="icon" width={35} height={35} />
            </div>

            <h2>Headless</h2>
            <p>
              Plug in with any pre-purchase experience platform and manage your fulfillment operations seamlessly.
              Launch new features and experiences quickly with independent front-end development.
            </p>
          </div>
          <div className={styles["headless-image"]}>
            <Image src="/we-deliver/image.png" alt="img" width={40} height={40} layout="responsive" />
          </div>

        </div>
        <div className={styles.featureCard}>
          <div className={styles.cardLogoContainer}>
            <Image src="/modernise-icons/Composable_Commerce_white_bg.svg" alt="icon" width={45} height={45} />
          </div>
          <h2>Composable</h2>
          <p>
            100% composable components that allow you to build your supply chain systems the way you want.
            Connect various services and third-party tools without restrictions for maximum operational efficiency.
          </p>
        </div>
        <div className={styles.featureCard}>
          <div className={styles.cardLogoContainer}>
            <Image src="/modernise-icons/icons8-cloud-native-64.png" alt="icon" width={35} height={35} />
          </div>
          <h2>Cloud-native</h2>
          <p>
          Cloud-Agnostic Headless Commerce: Socommerz empowers seamless cloud deployments for headless solutions,offering flexibility, scalability, and a future-ready commerce experience.</p>
        </div>
        <div className={styles.featureCard}>
          <div className={styles.cardLogoContainer}>
            <Image src="/modernise-icons/icons8-agile-64.png" alt="icon" width={35} height={35} />
          </div>
          <h2>Agile</h2>
          <p>
            Build highly adaptable and agile workflows that change with market trends.
            Modular capability for customers insights,engagements,interactions hooked with external plugins.
          </p>
        </div>
        <div className={`${styles.featureCard}`}>
          <div className={styles.cardLogoContainer}>
            <Image src="/user.png" alt="icon" width={35} height={35} />
          </div>
          <h2>User-friendly</h2>
          <p>A CMS-powered admin portal designed to streamline business operations and customer journey flows, featuring an intuitive UI and easy-to-use no-code editors to simplify task management.

          </p>
        </div>
      </div>
    </div>
  );
}

export default WeDeliver;
